export const ALL_KPIS_TAB_VALUE = 'ALL' as const
export const ALL_KPIS_TAB_NAME = 'All'
